import InitialForm from "../screens/InitialForm/InitialForm";
import { INITIAL_ROUTE } from "../utils/constants/routes";

export const initialRoutes = [
  {
    path: INITIAL_ROUTE,
    component: InitialForm,
  },
];
